import { create } from 'zustand';
import { User } from '@/core/auth';

interface SessionState {
  user: User | null;
  token: string | null;
  setSession: (token: string, user: User) => void;
  clearSession: () => void;
  isAuthenticated: boolean;
}

export const useSession = create<SessionState>((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,
  setSession: (token, user) => set({ token, user, isAuthenticated: true }),
  clearSession: () => set({ token: null, user: null, isAuthenticated: false }),
}));
